import { hyphenatableWordInput } from '@utils/component-framework';
import { usePageContext } from '../../../../context.js';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useInputState } from '../../hook.use-input-state.js';
import { HyphenatableWordEditable } from './atom.editable.word.js';
import { HyphenatableWordFacit } from './atom.facit.word.js';
import { word } from './input.word.style.js';
import { jsx } from 'react/jsx-runtime';

function HyphenatableWordInput(props) {
  const pageContext = usePageContext();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => hyphenatableWordInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.node.id])
  });
  const state = useInputState(props.node, inputEntry);
  if (!props.node.meta.hyphenatable) {
    return /*#__PURE__*/jsx("div", {
      className: word,
      "data-page-context": pageContext,
      "data-hyphenatable": false,
      children: props.node.text
    });
  }
  if (state !== "input") {
    return /*#__PURE__*/jsx(HyphenatableWordFacit, {
      ...props,
      state: state
    });
  }
  return /*#__PURE__*/jsx(HyphenatableWordEditable, {
    ...props
  });
}

export { HyphenatableWordInput };
//# sourceMappingURL=input.word.js.map
